<script>
import "@picocss/pico";
import { onMount } from 'svelte';
import { ethers } from 'ethers';
import { Icon } from 'svelte-icons-pack';
import { BiCandles } from "svelte-icons-pack/bi";

import Calendar  from './components/Calendar.svelte';
import Netliqs from './components/Netliqs.svelte';
import Trades from './components/Trades.svelte';
import Gas from './components/Gas.svelte';
import Vig from './components/Vig.svelte';
import Fees from './components/Fees.svelte';
import Return from './components/Return.svelte';
import ExcessReturn from "./components/ExcessReturn.svelte";
import TradingViewWidget from "svelte-tradingview-widget";
import MediaQuery from 'svelte-media-queries';

const today = new Date().toISOString().split('T')[0];
const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
const monthAgo = new Date(Date.now() - 2592000000).toISOString().split('T')[0];
const weekAgo = new Date(Date.now() - 604800000).toISOString().split('T')[0];

let fromDate = yesterday;
let toDate = today;

let wallet = "";
let lines = {sell: 0, buy: 0};
let netliqs = [{usd_value: 0, timestamp: 0}];
let todayNetliq = [{usd_value: 0, timestamp: 0}];
let gas = {gas_eth: 0};
let vig = {vig_eth: 0};
let fees = {eth: 0, usdc: 0};
let dailyReport = [];
let ethPrice = 0;

onMount(() => {
		checkMetaMask();
		if (ethereum) {
			ethereum.on('accountsChanged', handleAccountsChanged);
		}
});

function checkMetaMask() {
	const { ethereum } = window;
	return Boolean(ethereum && ethereum.isMetaMask);
}

async function connectMetaMask() {
		const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
		wallet = await ethers.utils.getAddress(accounts[0]);
		console.log(wallet);
}

async function handleAccountsChanged(accounts) {
	if (accounts.length === 0) {
		wallet = null;
	} else {
		wallet = await ethers.utils.getAddress(accounts[0]);
	}
}

function dayBack() {
  fromDate = yesterday;
  handleSubmit();
}
function weekBack() {
  fromDate = weekAgo;
  handleSubmit();
}
function monthBack() {
  fromDate = monthAgo;
  handleSubmit();
}
// Fetch data from API on submit, will be replaced with metamask wallet connect
async function handleSubmit() {
  const linesUrl  = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/lines?from=${fromDate}&to=${toDate}`;
  fetch(linesUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      lines = data;
    })
    .catch(error => {
      console.error('There was a problem with the lines fetch operation:', error);
    });

  const todayNetliqsUrl = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/netliqs?from=${yesterday}&to=${today}`;
  fetch(todayNetliqsUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      todayNetliq = data;
      // drop all wallet attribute from netliqs array
      todayNetliq = netliqs.map(({wallet, ...rest}) => rest);
    })
    .catch(error => {
      console.error('There was a problem with the netliqs fetch operation:', error);
    });

  const netliqsUrl = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/netliqs?from=${fromDate}&to=${toDate}`;
  fetch(netliqsUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      netliqs = data;
      // drop all wallet attribute from netliqs array
      netliqs = netliqs.map(({wallet, ...rest}) => rest);
    })
    .catch(error => {
      console.error('There was a problem with the netliqs fetch operation:', error);
    });

  const gasUrl = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/gas?from=${fromDate}&to=${toDate}`;
  fetch(gasUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      gas = data;
    })
    .catch(error => {
      console.error('There was a problem with the gas fetch operation:', error);
    });

  const vigUrl = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/vig?from=${fromDate}&to=${toDate}`;
  fetch(vigUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      vig = data;
    })
    .catch(error => {
      console.error('There was a problem with the vig fetch operation:', error);
    });

  const feesUrl = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/fees?from=${fromDate}&to=${toDate}`;
  fetch(feesUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      fees = data;
    })
    .catch(error => {
      console.error('There was a problem with the fees fetch operation:', error);
    });

  const dailyReportUrl = `https://ve0usf7fyh.execute-api.us-east-1.amazonaws.com/default/wallet/${wallet}/daily-report?from=${fromDate}&to=${toDate}`;
  fetch(dailyReportUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json(); })
    .then(data => {
      dailyReport = data;
    })
    .catch(error => {
      console.error('There was a problem with the daily report fetch operation:', error);
    });

  const ethPriceUrl = "https://api.coinbase.com/v2/prices/ETH-USD/spot";
  fetch(ethPriceUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      ethPrice = data['data']['amount'];
    })
    .catch(error => {
      console.error('There was a problem with the eth price fetch operation:', error);
    });
}

// TradingViewWidget options
let options = { symbol: "BITSTAMP:ETHUSD", 
  theme: "dark", 
  interval: "120", 
  allow_symbol_change: false, 
};
</script>

<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
  <h1>Tsbot Performance 🚀</h1>
  <div>
    {#if checkMetaMask}
		  <button on:click={connectMetaMask} class="enableEthereumButton" style="background-color: green;">{wallet? `${wallet.slice(0, 6)}...${wallet.slice(-4)}` : 'Connect'}</button>
	  {/if}
	</div>
</div>

<div style="display: flex; flex-direction: row;">
  <Calendar bind:fromDate={fromDate} bind:toDate={toDate} />
  <div style="padding-top: 50px">
    <button on:click={dayBack}>One Day</button>
    <button on:click={weekBack}>Last 7 days</button>
    <button on:click={monthBack}>Last 30 days</button>
    <button on:click={handleSubmit}>Submit</button>
  </div>
</div>

<div class=grid>
  <article>
    <Trades {lines}/>
  </article>

  <article>
    <Return {dailyReport}/>
  </article>

  <article>
    <ExcessReturn {dailyReport}/>
  </article>

  <article>
    <Gas {gas} {ethPrice}/>
  </article>

  <article>
    <Fees {fees} {ethPrice}/>
  </article>

  <article>
    <Vig {vig} {ethPrice}/>
  </article>
</div>

<MediaQuery query='(min-width: 800px)' let:matches>
  {#if matches}
    <article>
      <h6>
        <Icon src={BiCandles} size="20" color="CornflowerBlue"/>
        ETH/USD Chart
      </h6>
      <div class="tradingview-widget-container" style="height:100%;width:100%">
        <TradingViewWidget {options} />
      </div>
    </article>
  {/if}
</MediaQuery>

<article>
  <Netliqs {netliqs}/>
</article>

<style>
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);  /* 3 columns */
  grid-template-rows: repeat(2, 270px);  /* 2 rows with a height of 200px */
  grid-gap: 10px;
}
button {
  height: 56px;
}
</style>

